import { gql } from '@apollo/client'
import { StarSuperLiteFragment } from '@src/graphql/fragment/star'

export default gql`
  query GetStarSuperLite($starID: String!) {
    getStar(StarID: $starID) {
      ...StarSuperLite
    }
  }
  ${StarSuperLiteFragment}
`
